import React from 'react';
import L from 'leaflet';

import { calculateOrientationShiftedPosition, cellMarkersReprPolySizesPerZoom } from 'utils/Map/mapUtils';

export default class LeafletAzimuthMarkerLine extends L.Polyline {
  private orientationMarkerInfo: any;
  private siteMarkerInfo: any;
  private currentCellMarkerSize: number;
  private highlightedStyle: L.PathOptions;
  private nonHighlightedStyle: L.PathOptions;
  private highlightedCriteriasRef: React.RefObject<any>;

  constructor(
    orientationMarkerInfo: any,
    siteMarkerInfo: any,
    highlightedCriteriasRef: React.RefObject<any>,
    options?: L.PolylineOptions
  ) {
    const baseOptions = {
      weight: 1,
      color: 'black',
      opacity: 0.5,
    };

    super([], { ...baseOptions, ...options });

    this.orientationMarkerInfo = orientationMarkerInfo;
    this.siteMarkerInfo = siteMarkerInfo;
    this.currentCellMarkerSize = 30;
    this.highlightedStyle = { weight: 3, color: 'red', opacity: 1 };
    this.nonHighlightedStyle = { weight: 1, color: 'black', opacity: 0.5 };
    this.highlightedCriteriasRef = highlightedCriteriasRef;

    this.on('pm:enable', (e: any) => e.target.pm.disable());
  }

  onAdd(map: L.Map) {
    super.onAdd(map);
    this._updateLength();
    this.verifyHighlightCriteria();
    this._map.on('zoomend', this._updateLength, this);
    return this;
  }

  onRemove(map: L.Map) {
    this._map.off('zoomend', this._updateLength, this);
    super.onRemove(map);
    return this;
  }

  verifyHighlightCriteria() {
    const needsHighlight = this.orientationMarkerInfo.markers.some(
      (cellMarkerInfo: any) =>
        this.highlightedCriteriasRef.current?.some(
          (highlightedCriteria: any) =>
            cellMarkerInfo[highlightedCriteria.id] &&
            cellMarkerInfo[highlightedCriteria.id] === highlightedCriteria.value
        )
    );

    this.setStyle(
      needsHighlight ? this.highlightedStyle : this.nonHighlightedStyle
    );
  }

  _updateLength() {
    const map = this._map;
    const zoomLevel = map.getZoom();

    this.currentCellMarkerSize =
    cellMarkersReprPolySizesPerZoom[zoomLevel] ||
      this.currentCellMarkerSize;

    const endCoordinates = calculateOrientationShiftedPosition(
      map,
      this.currentCellMarkerSize,
      this.siteMarkerInfo.location,
      this.orientationMarkerInfo.orientation,
      this.orientationMarkerInfo.markers.length + 1
    );

    this.setLatLngs([this.siteMarkerInfo.location, endCoordinates]);
  }
}
